import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/* CSS */
import shared from '../../styles/shared.module.css';
import styles from './StatDetailOverlay.module.css';

const StatDetailOverlay = ({ label, front, back, info, onClose }) => {

    const [flipped, setFlipped] = useState(false);
    useEffect(() => {
        const raf = requestAnimationFrame(() => setFlipped(true));
        return () => cancelAnimationFrame(raf);
    }, []);

    // Side effects while the overlay is open: Escape-to-close + lock body scroll.
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKey);

        // Stop the page behind from scrolling while the modal is up
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        // Cleanup runs when the overlay unmounts (or before re-running the effect)
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [onClose]);

    return createPortal(
        <div
            className={shared.modalOverlay}
            data-modal-overlay
            role="dialog"
            aria-modal="true"
            aria-label={`${label} details`}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className={styles.flipScene}>
                <div className={`${styles.flipCard} ${flipped ? styles.flipCardFlipped : ''}`}>

                    {/* FRONT — a copy of the clicked card */}
                    <div className={`${styles.flipFace} ${styles.flipFront}`}>
                        {front}
                    </div>

                    {/* BACK — the detail panel */}
                    <div className={`${styles.flipFace} ${styles.flipBack}`}>
                        <div className={styles.panelHeader}>
                            <div className={styles.panelTitle}>
                                <h3 className={styles.panelLabel}>{label}</h3>
                                <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">×</button>
                            </div>
                            <div className={styles.panelSubTitle}>{info}</div>
                        </div>
                        <div className={styles.panelBody}>
                            {back}
                        </div>
                    </div>

                </div>
            </div>
        </div>,
        document.body
    );
};

export default StatDetailOverlay;
